<app-basic-modal [status]="modalStatus" [mobileFullScreen]="false" [persistXToClose]="true" [modalName]="'image_text_popup'">
  <div class="cont-modal">
    <img *ngIf="img !== ''" src="assets/svg/prodcuts-change-delivery.svg" alt="cambio tipo de envio">
    <h2 class="title">{{title}}</h2>
    <app-button [buttonId]="'button-close-simple-modal-image-text'" [title]="'Aceptar'" [customClasses]="'main md'" (click)="closeModal()"></app-button>
  </div>
</app-basic-modal>
